var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );
dependencies["front/components/AwardsADGWinnersList/AwardsADGWinnersList.jinja"] = require( "front/components/AwardsADGWinnersList/AwardsADGWinnersList.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/AwardsADGEligiblePopup/AwardsADGEligiblePopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/AwardsADGEligiblePopup/AwardsADGEligiblePopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/AwardsADGEligiblePopup/AwardsADGEligiblePopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
env.getTemplate("front/components/AwardsADGWinnersList/AwardsADGWinnersList.jinja", false, "assets/app/front/pages/AwardsADGEligiblePopup/AwardsADGEligiblePopup.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "AwardsADGWinnersList")) {
var t_10 = t_7.AwardsADGWinnersList;
} else {
cb(new Error("cannot import 'AwardsADGWinnersList'")); return;
}
context.setVariable("AwardsADGWinnersList", t_10);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupTopLayer"))(env, context, frame, runtime, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
output += t_11;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_14,t_13) {
if(t_14) { cb(t_14); return; }
output += t_13;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupTopLayer(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"BasePopup-print\">\n        ";
output += runtime.suppressValue((lineno = 7, colno = 30, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["popup-print","0 0 40 35",runtime.makeKeywordArgs({"caller": (function (){var macro_t_15 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_16 = "";;
frame = frame.pop();
return new runtime.SafeString(t_16);
});
return macro_t_15;})()})])), env.opts.autoescape);
output += "\n        <div class=\"BasePopup-tip\">Clicking on this icon will allow you to print a simplified version of this page.</div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"AwardsADGEligiblePopup\">\n\n        <div class=\"AwardsADGEligiblePopup-header\">\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"parent") == "awards") {
output += "\n                <div class=\"AwardsADGEligiblePopup-title\"><a href=\"";
output += runtime.suppressValue((lineno = 17, colno = 70, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards_adg"])), env.opts.autoescape);
output += "\">ADG Awards</a></div>\n            ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"parent") == "rules") {
output += "\n                <div class=\"AwardsADGEligiblePopup-title\"><a href=\"";
output += runtime.suppressValue((lineno = 19, colno = 70, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["submissions:rules"])), env.opts.autoescape);
output += "\">Rules & Specifications</a></div>\n            ";
;
}
;
}
output += "\n\n            <div class=\"AwardsADGEligiblePopup-caption\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"caption"), env.opts.autoescape);
output += "</div>\n\n            ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"categories"))) {
output += "\n            <div class=\"AwardsADGEligiblePopup-switchers\">\n                <div class=\"AwardsADGEligiblePopup-switchersCaption\">Select Category:</div>\n                ";
frame = frame.push();
var t_19 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"categories");
if(t_19) {t_19 = runtime.fromIterator(t_19);
var t_18 = t_19.length;
for(var t_17=0; t_17 < t_19.length; t_17++) {
var t_20 = t_19[t_17];
frame.set("category", t_20);
frame.set("loop.index", t_17 + 1);
frame.set("loop.index0", t_17);
frame.set("loop.revindex", t_18 - t_17);
frame.set("loop.revindex0", t_18 - t_17 - 1);
frame.set("loop.first", t_17 === 0);
frame.set("loop.last", t_17 === t_18 - 1);
frame.set("loop.length", t_18);
output += "\n                    <div class=\"AwardsADGEligiblePopup-switchersItem  ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0) {
output += "AwardsADGEligiblePopup-switchersItem--active";
;
}
output += "\" data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_20),"category"), env.opts.autoescape);
output += "</div>\n                ";
;
}
}
frame = frame.pop();
output += "\n            </div>\n        ";
;
}
output += "\n        </div>\n\n        ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"categories"))) {
output += "\n        <div class=\"AwardsADGEligiblePopup-categorySelector\">\n            <div class=\"AwardsADGEligiblePopup-categorySelectorText\">Select Category: <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"categories")),0)),"category"), env.opts.autoescape);
output += "</span></div>\n            <div class=\"AwardsADGEligiblePopup-categorySelectorIcon\">\n                ";
output += runtime.suppressValue((lineno = 38, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-down","0 0 22 12",runtime.makeKeywordArgs({"caller": (function (){var macro_t_21 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_22 = "";;
frame = frame.pop();
return new runtime.SafeString(t_22);
});
return macro_t_21;})()})])), env.opts.autoescape);
output += "\n            </div>\n            <div class=\"AwardsADGEligiblePopup-categorySelectorDropdown\">\n                <div class=\"AwardsADGEligiblePopup-categorySelectorDropdownWrapper\">\n                    ";
frame = frame.push();
var t_25 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"categories");
if(t_25) {t_25 = runtime.fromIterator(t_25);
var t_24 = t_25.length;
for(var t_23=0; t_23 < t_25.length; t_23++) {
var t_26 = t_25[t_23];
frame.set("category", t_26);
frame.set("loop.index", t_23 + 1);
frame.set("loop.index0", t_23);
frame.set("loop.revindex", t_24 - t_23);
frame.set("loop.revindex0", t_24 - t_23 - 1);
frame.set("loop.first", t_23 === 0);
frame.set("loop.last", t_23 === t_24 - 1);
frame.set("loop.length", t_24);
output += "\n                        <div class=\"AwardsADGEligiblePopup-categorySelectorDropdownItem ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0) {
output += "AwardsADGEligiblePopup-categorySelectorDropdownItem--active";
;
}
output += "\" data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_26),"category"), env.opts.autoescape);
output += "</div>\n                    ";
;
}
}
frame = frame.pop();
output += "\n                </div>\n\n            </div>\n        </div>\n        ";
;
}
output += "\n\n        <div class=\"AwardsADGEligiblePopup-content\">\n            ";
frame = frame.push();
var t_29 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"categories");
if(t_29) {t_29 = runtime.fromIterator(t_29);
var t_28 = t_29.length;
for(var t_27=0; t_27 < t_29.length; t_27++) {
var t_30 = t_29[t_27];
frame.set("category", t_30);
frame.set("loop.index", t_27 + 1);
frame.set("loop.index0", t_27);
frame.set("loop.revindex", t_28 - t_27);
frame.set("loop.revindex0", t_28 - t_27 - 1);
frame.set("loop.first", t_27 === 0);
frame.set("loop.last", t_27 === t_28 - 1);
frame.set("loop.length", t_28);
output += "\n                <div class=\"AwardsADGEligiblePopup-list  ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0) {
output += "AwardsADGEligiblePopup-list--active";
;
}
output += "\" data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\">\n                    <div class=\"AwardsADGEligiblePopup-listWrapper\">\n                        ";
output += runtime.suppressValue((lineno = 55, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "AwardsADGWinnersList"), "AwardsADGWinnersList", context, [runtime.makeKeywordArgs({"data": t_30})])), env.opts.autoescape);
output += "\n                    </div>\n                </div>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupTopLayer: b_popupTopLayer,
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/AwardsADGEligiblePopup/AwardsADGEligiblePopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/AwardsADGEligiblePopup/AwardsADGEligiblePopup.jinja
// module id = 212
// module chunks = 0